import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const EPAY_SERVER = ConfigurationService.get(ConfigurationKeys.EPAY_SERVER);
const EPAY_TENANT = ConfigurationService.get(ConfigurationKeys.EPAY_TENANT);
const EPAY_API = `${EPAY_SERVER}/rest/v1/checkout/${EPAY_TENANT}`;

const PAYOUT_SERVER = ConfigurationService.get(ConfigurationKeys.PAYOUT_SERVER);

export const PAYMENT_METHODS_URL =
  // eslint-disable-next-line max-len
  `${EPAY_API}/{language}/TOKENS?userName={username}&accessHash={accessHash}&siteSubcat=cam4.com`;
export const PAYMENT_PROCESSORS_URL = `${PAYOUT_SERVER}/rest/v1/users`;
export const CASH_OUT_URL = `${PAYOUT_SERVER}/rest/v1/requests`;
export const PAYMENT_LINK_PROCESSOR_URL = `${PAYOUT_SERVER}/rest/v1/users/signup`;
export const PAYMENT_LINK_PROC_TO_EXTERNAL_ACCOUNT = `${PAYOUT_SERVER}/rest/v1/users/link`;
export const PAYMENT_LINK_PROCESSOR_STORE_URL = `${PAYOUT_SERVER}/rest/v1/users/store`;
export const PAYMENT_UPDATE_PROCESSOR_URL = `${PAYOUT_SERVER}/rest/v1/users/accounts/{accountId}`;
export const PAYMENT_DELETE_PROCESSOR_URL = `${PAYOUT_SERVER}/rest/v1/users/accounts/{accountId}`;
export const GOLD_MEMBERSHIPS_URL =
  // eslint-disable-next-line max-len
  `${EPAY_API}/{language}/MEMBERSHIP?userName={username}&accessHash={accessHash}&siteSubcat=cam4.com`;
export const GET_AUTOPAYMENT_DATA_URL = `${PAYOUT_SERVER}/rest/v1/autoPayment`;
export const CREATE_AUTOPAYMENT_URL = `${PAYOUT_SERVER}/rest/v1/autoPayment`;
export const UPDATE_AUTOPAYMENT_URL = `${PAYOUT_SERVER}/rest/v1/autoPayment/{autoPaymentId}`;
export const DELETE_AUTOPAYMENT_URL = `${PAYOUT_SERVER}/rest/v1/autoPayment/{autoPaymentId}`;
export const TWO_FA_URL = `${PAYOUT_SERVER}/rest/v1/validateTwoFaCode`;
export const RESEND_TWO_FA_URL = `${PAYOUT_SERVER}/rest/v1/resendTwoFaCode`;
